var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"showDialog":_vm.showDialog,"title":_vm.dialogTitle,"maxWidth":900,"hideActions":true},on:{"cancel":_vm.cancel}},[_c('v-card-text',[_c('data-table',{staticClass:"mx-2 my-2",attrs:{"headers":_vm.headers,"tableData":_vm.getData,"noFooter":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }